/* istanbul ignore file */
import { ILayer, IMarker } from "@sureview/v2-mapping";
import { MapItemData } from "../map-layers/types";
import { NotificationOptions } from "vue-notification";
export interface MapSetupState {
	GroupsWithLayers: MapSetupGroup[];
	SelectedMapLayerId: number | null;
	unconvertedMaps: Map[];
	notificationOptions: NotificationOptions | null;
}

export class MapSetupItem extends MapItemData {}

export class MapSetupLayer {
	constructor(layer = null) {
		if (layer) {
			(this.mapLayerId = layer.mapLayerID ?? layer.mapLayerId),
				(this.minElevation = layer.minElevation),
				(this.maxElevation = layer.maxElevation),
				(this.groupId = layer.groupID ?? layer.groupId),
				(this.groupTitle = layer.groupTitle),
				(this.title = layer.title),
				(this.ne = layer.ne),
				(this.nw = layer.nw),
				(this.se = layer.se),
				(this.sw = layer.sw),
				(this.image = this.getLayerImage(layer)),
				(this.rotation = layer.rotation),
				(this.visible = false),
				((this.layerItems = this.setItems(layer.layerItems)),
				(this.itemCount = layer.itemCount),
				(this.latLong = layer.latLong ?? null),
				(this.isUnlinkedItemsLayer = layer.isUnlinkedItemsLayer));
		}
	}
	public mapLayerId: number = 0;
	public minElevation: number | null = null;
	public maxElevation: number | null = null;
	public groupId: number = 0;
	public groupTitle: string = undefined;
	public title: string = undefined;
	public ne: string = undefined;
	public nw: string = undefined;
	public se: string = undefined;
	public sw: string = undefined;
	public image: string = undefined;
	public rotation: number = 0;
	public visible: boolean = false;
	public layerItems: MapSetupItem[] = [];
	public latLong?: string = null;
	public itemCount: number = 0;
	public isUnlinkedItemsLayer: boolean = false;

	private setItems(items) {
		let itemsToAdd: MapSetupItem[] = [];

		if (items && items.length > 0) {
			items.forEach(i => {
				itemsToAdd.push(i);
			});
		}

		return itemsToAdd;
	}

	private getLayerImage(layer) {
		if (layer.image) {
			if (!layer.image.includes("data:image")) {
				return "data:image/png;base64, " + layer.image;
			}
			return layer.image;
		}
	}

	public reset() {
		(this.mapLayerId = undefined),
			(this.minElevation = 0),
			(this.maxElevation = 0),
			(this.groupId = undefined),
			(this.groupTitle = undefined),
			(this.title = undefined),
			(this.ne = undefined),
			(this.nw = undefined),
			(this.se = undefined),
			(this.sw = undefined),
			(this.image = undefined),
			(this.rotation = 0),
			(this.visible = true),
			(this.layerItems = []);
	}
}

export class MapSetupGroup {
	constructor(group = null) {
		if (group) {
			this.address = group.address;
			this.groupId = group.groupID ?? group.groupId;
			this.groupTypeId = group.groupTypeID;
			this.notes = group.notes;
			this.parentGroupId = group.parentGroupID ?? group.parentGroupId;
			this.title = group.title;
			this.mapLayers = [];
			this.kebabTitle = this.makeKebabCase(this.title);
			this.latLong = group.latLong;
		}
	}
	public address: string = undefined;
	public groupId: number = undefined;
	public groupTypeId: number = undefined;
	public notes: string = undefined;
	public parentGroupId: number | null = undefined;
	public title: string = undefined;
	public mapLayers: MapSetupLayer[] = [];
	public kebabTitle: string = undefined;
	public latLong: string = undefined;

	private makeKebabCase(value: string) {
		if (value) {
			return value.replace(" ", "-");
		}
	}
}

export class LayerMap {
	[s: number]: ILayer;
}
export class ItemMap {
	[s: number]: IMarker;
}
export class SelectionObject {
	constructor(mapItemObject = null, typeId = null) {
		if (mapItemObject) {
			(this.title = mapItemObject.title),
				(this.typeId = typeId),
				(this.objectId = this.getObjectId(mapItemObject));
		}
	}
	public typeId: number = 0;
	public title: string = "";
	public objectId: number = 0;
	private getObjectId(mapItemObject) {
		let objectID = -1;
		// CHANGE TO SWITCH LATER
		if (this.typeId == 0 && mapItemObject.hasOwnProperty("objectID")) {
			// Map Item
			objectID = mapItemObject.objectID;
		}
		if (this.typeId == 1 && mapItemObject.hasOwnProperty("deviceID")) {
			// Camera
			objectID = mapItemObject.deviceID;
		}
		if (this.typeId == 2 && mapItemObject.hasOwnProperty("deviceID")) {
			// Microphone
			objectID = mapItemObject.deviceID;
		}
		if (this.typeId == 3 && mapItemObject.hasOwnProperty("deviceID")) {
			// Relay
			objectID = mapItemObject.deviceID;
		}
		if (this.typeId == 4 && mapItemObject.hasOwnProperty("responseID")) {
			// Alarm
			objectID = mapItemObject.responseID;
		}
		if (this.typeId == 5 && mapItemObject.hasOwnProperty("deviceID")) {
			// Output
			objectID = mapItemObject.deviceID;
		}
		if (this.typeId == 6 && mapItemObject.hasOwnProperty("?")) {
			// Geofence
			objectID = mapItemObject.responseID;
		}

		return objectID;
	}
}

export interface MapSetupLayerItemRequest {
	mapSetupLayers: MapSetupLayer[],
	mapSetupLayerItem: MapSetupItem
}

export interface Devices {
	objectID: Number,
    title: String
    groupID: Number,
    deviceTypeID: Number,
    settingsMeta: String
}

export interface IMapLayerDisplay {
	title: string;
	mapLayerID: number;
}

export interface MapLayerRequest {
	MapLayerId: number;
	North: DoubleRange;
	South: DoubleRange;
	East: DoubleRange;
	West: DoubleRange;
	Elevation: number;
}

export interface Map {
	mapID: number;
	groupId: number;
	orderNum: number;
	title: string;
	picture: number[];// Byte array
	converted: boolean;
	syncIdentifier: string;
}

export interface mapItemsUpdated {
	layerId: number;
	itemId: number;
	oldLatLong: string;
}

export interface closeInfoWindowDeleteData {
	deletedItemId: number
}

export interface closeInfoWindowUpdateData {
	updatedItemId: number,
	removedLayerIds: number[]
}